export default __webpack_public_path__ + "static/ehm-smooth-silky-5aaccbd13a0c9d89036f797219371a4a.png";